// Cognito connection details (Phase 7). These are public identifiers — safe in
// client code. The user pool is the directory; the client id is this web app.
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-2_LDurkVu5N',
      userPoolClientId: '2ir6c60b4o3e5u1dsddjookbr',
      // The pool uses email as the username, so sign-in is email-based.
      loginWith: { email: true },
    },
  },
};
